import { getAxiosErrResponse, getPCErrorField } from './api_errors'
import { FieldActionType } from '../actions'

const alwaysSkipFeatures: string[] = [
  // This type is called every time a user sets a field value, it is
  // too noisy to care about (actual validation problems on submit are caught by
  // the Documents type(s)).
  FieldActionType.VALIDATE,
]

const alwaysSkipErrorCodes: string[] = [
  // ErrExpiredToken is returned from otherwise valid but expired auth tokens,
  // and could happen once a day - there is no need to log this.
  'ErrExpiredToken',
]

// certain request types are not worth reporting to DataDog.
// This is meant to be expanded upon later as we find more noisy errors.
export const shouldSendDatadog = (error: unknown, reqType: string): boolean => {
  if (alwaysSkipFeatures.includes(reqType)) return false
  const code = getPCErrorField(error, 'code')
  if (!code) return true
  return !alwaysSkipErrorCodes.includes(code)
}

type SentryGoof = {
  code: string
  message: string
  inputs?: Record<string, string>
  fault?: boolean
}

// TO-14165 Sentry replaced with DataDog logging, need to determin if this is still needed
// and update for DataDog if so.
// setSentryErrorData gathers relevant data from an Axios error and adds it
// to a provided Sentry Scope.
// export const setSentryErrorData = (scope: Scope, error: unknown) => {
//   const resp = getAxiosErrResponse(error)
//   if (resp) {
//     scope.setContext('request-status', {
//       status: resp.status,
//       statusText: resp.statusText,
//     })
//     scope.setTag('statusCode', resp.status)
//   }

//   const code = getPCErrorField(error, 'code')
//   const message = getPCErrorField(error, 'message')
//   if (!code && !message) {
//     return
//   }
//   const ctx: SentryGoof = {
//     code: 'UNSET',
//     message: 'UNSET',
//   }
//   if (code) {
//     ctx.code = code
//     scope.setTag('errorCode', code)
//   }
//   if (message) {
//     ctx.message = message
//     scope.setTag('errorMessage', message)
//   }
//   const inputs = getPCErrorField(error, 'inputs')
//   if (inputs) {
//     ctx.inputs = inputs
//   }
//   const fault = getPCErrorField(error, 'fault')
//   if (fault) {
//     ctx.fault = fault
//   }
//   scope.setContext('error', ctx)
// }
